<template>
  <div id="app"
       class="container-fluid p-0"
       role="grid">
    <header id="bar-top"
            class="fixed-top bg-light w-100 p-0"
            role="grid">
      <div id="banner"
           class="center w-100 px-3 px-3 d-flex justify-content-between align-items-center position-relative">
        <div class="d-flex flex-column flex-md-row align-items-center"
             role="grid">
          <img class="bannerCGCourtage d-none d-md-inline-block"
               src="../../assets/images/logo-CGcourtage.svg"
               alt="bannière CG Courtage">
          <div class="d-inline-block align-middle ml-0 ml-md-3"
               role="grid">
            <a href="tel:+33561862263"
               class="d-block text-secondary font-weight-bold mb-0">05 61 86 22 63</a>
            <a href="mailto:contact@cgcourtage.fr"
               class="d-block text-dark"
               id="contactCGC">contact@cgcourtage.fr</a>
          </div>
        </div>
        <router-link id="compteLink"
                     class="align-self-end position-absolute"
                     :to="{ name: 'Connexion' }">
          <img id="logoMonCompte"
               src="../../assets/images/bt-espace-client.svg"
               alt="logo mon compte">
        </router-link>
        <router-link class="parallelogramRight d-none d-md-flex align-items-center"
                     :to="{ name: 'Achat', params: { typeSearched: 'bien' } }">
          <img class="bannerTolusImmo d-none d-md-inline-block"
              src="../../assets/images/logo-tolusimmo.svg"
              alt="bannière Tolus Immo">
        </router-link>
      </div>
      <b-navbar toggleable="md"
                type="dark"
                variant="dark px-0 py-0">
        <b-navbar-toggle target="top-nav-collapse"></b-navbar-toggle>
        <b-collapse id="top-nav-collapse"
                    class="center"
                    is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'Home' }"
                        exact-active-class="active"
                        class="text-uppercase">Accueil</b-nav-item>
            <b-nav-item :to="{ name: 'IngenierieConseilPatrimoniaux' }"
                        exact-active-class="active"
                        class="text-uppercase">INGÉNIERIE & CONSEILS PATRIMONIAUX</b-nav-item>
            <b-nav-item :to="{ name: 'EpargneRetraite' }"
                        exact-active-class="active"
                        class="text-uppercase">ÉPARGNE & RETRAITE</b-nav-item>
            <b-nav-item :to="{ name: 'AssurancePrevoyance' }"
                        exact-active-class="active"
                        class="text-uppercase">ASSURANCES & PRÉVOYANCE</b-nav-item>
            <b-nav-item :to="{ name: 'FinancementImmobilierProfessionnels' }"
                        exact-active-class="active"
                        class="text-uppercase">FINANCEMENT IMMO & PROS</b-nav-item>
            <b-nav-item :to="{ name: 'InfosCGC' }"
                        exact-active-class="active"
                        class="text-uppercase text-nowrap">Focus</b-nav-item>
            <b-nav-item :to="{ name: 'Equipe' }"
                        exact-active-class="active"
                        class="text-uppercase text-nowrap">Notre Équipe</b-nav-item>
            <b-nav-item :to="{ name: 'ContactCGC' }"
                        exact-active-class="active"
                        class="text-uppercase">Contact</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main class="row w-100 h-100 m-0 main-row d-flex flex-nowrap"
          role="grid">
      <router-view />
    </main>
    <footer id="bar-bottom">
      <div id="footer-banner"
           class="col px-0 bg-primary">
        <ul class="row center list-unstyled d-flex flex-column flex-sm-row justify-content-center w-100 px-3 px-sm-0">
          <li
              class="d-flex flex-column justify-content-between align-items-center border-right px-3 py-3 py-sm-0 mx-3 mx-sm-0">
            <img class="bannerCGCourtage"
                 src="../../assets/images/logo-CGcourtage.svg"
                 alt="bannière CG Courtage">
            <a class="text-center openSans-bold nav-link text-secondary small-ls h4"
               href="https://www.facebook.com/CGCOURTAGE"
               target="_blank"><u>Suivez-nous sur</u><img src="../../assets/images/picto-facebook-rose.svg" alt="logo FaceBook" class="ml-3"></a>
          </li>
          <li class="d-flex flex-column justify-content-between px-3 py-3 py-sm-0 mb-3 mb-sm-0 mx-3 mx-sm-0">
            <p class="bold text-light mb-0 mb-md-1 mb-lg-3">Vous avez une question ou une suggestion ?</p>
            <p class="text-light mb-0 mb-md-1 mb-lg-3">Nos équipes se tiennent à votre disposition pour toutes
              interrogations sur nos biens
              et services.</p>
              <div
                id="contactUs"
                class="bg-light">
                <b-button
                  :to="{ name: 'ContactCGC' }"
                  squared
                  variant="outline-primary w-100">
                  Contactez-nous
                </b-button>
              </div>
          </li>
        </ul>
      </div>
      <b-navbar id="bar-bottom"
                toggleable="md"
                type="dark"
                variant="col-12 bg-dark py-1">
        <b-navbar-toggle target="bottom-nav-collapse"></b-navbar-toggle>
        <b-collapse id="bottom-nav-collapse"
                    class="center"
                    is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'MentionsCGC' }"
                        class="text-primary">Mentions légales</b-nav-item>
            <b-nav-item :to="{ name: 'Equipe' }"
                        class="text-primary">À propos de nous</b-nav-item>
            <b-nav-item :to="{ name: 'ContactCGC' }"
                        class="text-primary">Nous contacter</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { NavbarPlugin, ButtonPlugin } from 'bootstrap-vue'
Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)

export default {
  name: 'App',
  data () {
    return {
      isFinancement: false,
      isAssurance: false
    }
  },
  methods: {
    checkLink () {
      switch (this.$router.currentRoute.path) {
        case '/CGC/financement.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/financementImmobilier.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/rachatCredits.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/renegociationPret.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/pretsProfessionnels.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/pretsHypotecaires.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/remere.html':
          this.isFinancement = true
          this.isAssurance = false
          break
        case '/CGC/assurance.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        case '/CGC/assuranceCredit.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        case '/CGC/assuranceRevenus.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        case '/CGC/fraisMedicaux.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        case '/CGC/autoMoto.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        case '/CGC/assuranceBien.html':
          this.isFinancement = false
          this.isAssurance = true
          break
        default:
          this.isFinancement = false
          this.isAssurance = false
      }
    }
  },
  beforeMount () {
    this.checkLink()
  },
  updated () {
    this.checkLink()
  }
}

</script>

<style lang="scss" scoped>

$heigtBarTop: 7.8rem;
$heightNavBar: 3rem;

.bannerTolusImmo {
  width: auto;
  height: 4.5rem !important;
}

#bar-top {

  .parallelogramRight {
    height: 100% !important;
    box-shadow: 0px 3px 6px var(--dark);
    transform: skew(-25deg);
    padding: 0 2rem !important;
    .bannerTolusImmo {
      filter: grayscale(1);
      transform: skew(25deg);
    }
    figcaption {
      transform: skew(25deg);
    }
    figcaption::after {
      content: '\2303';
      display: inline-block;
      vertical-align: middle !important;
      font-weight: bolder !important;
      font-size: 1.4rem !important;
      transform: rotate(90deg);
      color: var(--secondary)
    }
  }
  .parallelogramRight:hover {
    .bannerTolusImmo {
      filter: grayscale(0);
    }
  }

  #banner {
    width: 100%;
    #compteLink {
      transform: translateX(-50%) !important;
      left: 50% !important;
    }
  }

  #logoMonCompte {
    width: auto;
    height: 5rem;
  }

  .bannerCGCourtage {
    width: auto;
    height: 4.5rem !important;
  }

  .navbar {
    width: 100% !important;
    .navbar-nav {
      width: 100% !important;
      justify-content: center !important;
    }
    .nav-link {
      position: relative;
      padding-bottom: 0 !important;
      padding-top: 0 !important;
      height: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      line-height: 1rem;
      color: white;
    }
    .nav-link:hover {
      color: var(--primary) !important;
    }
    .active{
      text-decoration: underline;
      text-decoration-color: var(--primary);
    }

    .nav-item:not(:last-of-type) {
      border-right: 1px solid var(--light) !important;
    }
  }
}

#bar-bottom {
  #footer-banner {
    ul {
      padding-bottom: 4.5rem !important;
      padding-top: 3.2rem !important;
      li {
        height: 12rem !important;
        width: 30% !important;
      }
    }
    .bannerCGCourtage {
      width: 100%;
      max-width: 18.6rem !important;
      background: white;
      box-shadow: 2px 2px 5px black;
      padding: 5px;
    }
    #contactUs {
      width: 11rem !important;
    }
    #emailToAlert {
      padding: 0.25rem !important;
    }
    #emailToAlert::placeholder {
      color: var(--secondary);
    }
  }
  .navbar {
    width: 100% !important;
    .navbar-nav {
      margin: 0 auto !important;
      max-width: 100% !important;
      .nav-item {
        white-space: nowrap !important;
        .nav-link {
          position: relative;
          color: var(--primary) !important;
          bottom: 0.4rem !important;
          padding: 0 2rem ;
        }
      }
      .nav-item:not(:last-of-type) {
        border-right: 1px solid var(--primary) !important;
      }
    }
  }
}

#navbarNavBottom ul li.nav-item a {
  padding: 1rem !important;
  margin: 0 !important;
}

@media (max-width: 575px) {

  #navbarNavBottom ul li.nav-item a.border-right {
    border-right: none !important;
    border-bottom: 1px solid var(--primary) !important;
  }
  #bar-bottom {
    #footer-banner {
      ul {
        li {
          width: calc(100% - 2rem) !important;
          border-right: none !important;
          border-bottom: 1px solid var(--light) !important;
        }
      }
    }
  }
}

@media (min-width: 576px) {
  #bar-bottom {
    #footer-banner {
      ul {
        li {
          width: 30% !important;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  #bar-bottom{
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }
      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--primary) !important;
        }
      }
    }
  }
  #bar-top{
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }
      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--gray) !important;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  #bar-top{
    .navbar {
      height: 2.9rem !important;
      .nav-item {
        height: 0.8rem !important;
      }
    }
  }
  #bar-bottom{
    .navbar {
      height: 2.9rem !important;
      .nav-item {
        height: 0.8rem !important;
      }
    }
  }
}

main {
  padding: $heigtBarTop 0 0 0 !important;
}

#bar-top {
  height: $heigtBarTop !important;
  #banner {
    height: calc(#{$heigtBarTop} - #{$heightNavBar});
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .nav-link {
    padding: 0 1rem !important;
  }
}

@media (min-width: 992px) {
  .nav-link {
    padding: 0 2rem !important;
  }
}

.btn-outline-primary:hover {
  color: var(--light) !important;
  border-color: var(--light) !important;
}
</style>
